var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrderActiveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9263 12.8275L18.5675 14.455C17.9463 17.255 15.75 19.25 12.5825 19.25H8.41752C5.25002 19.25 3.05377 17.255 2.43252 14.455L2.07377 12.8275C1.89877 12.0312 2.37127 11.13 3.13252 10.8237L4.37502 10.325L9.19627 8.3912C9.61627 8.22495 10.0625 8.13745 10.5 8.13745C10.9375 8.13745 11.3838 8.22495 11.8038 8.3912L16.625 10.325L17.8675 10.8237C18.6288 11.13 19.1013 12.0312 18.9263 12.8275Z",
    fill: "#465C8E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.625 7V8.26C16.625 8.56625 16.31 8.785 16.0212 8.6625L12.285 7.16625C11.1388 6.72 9.86125 6.72 8.70625 7.175L4.97875 8.67125C4.69 8.79375 4.375 8.575 4.375 8.26875V7C4.375 5.55625 5.55625 4.375 7 4.375H14C15.4437 4.375 16.625 5.55625 16.625 7Z",
    fill: "#465C8E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6875 4.375H8.3125V2.625C8.3125 2.14375 8.70625 1.75 9.1875 1.75H11.8125C12.2938 1.75 12.6875 2.14375 12.6875 2.625V4.375Z",
    fill: "#465C8E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderActiveIcon);
export default __webpack_public_path__ + "static/media/order-active-icon.565cc50490f645264a089bb763640635.svg";
export { ForwardRef as ReactComponent };